import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("iframe", {
  id: "kcpCancelFrame",
  name: "kcpCancelFrame",
  style: {"display":"none","width":"0","height":"0","border":"none"}
}, null, -1 /* HOISTED */)
const _hoisted_2 = {
  id: "kcpCancelForm",
  name: "kcpCancelForm",
  method: "POST"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "bookUid"
}, null, -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  type: "hidden",
  name: "bookDetailUid"
}
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("form", _hoisted_2, [
      _hoisted_3,
      ($props.isDailyBook)
        ? (_openBlock(), _createElementBlock("input", _hoisted_4))
        : _createCommentVNode("v-if", true),
      _createElementVNode("input", {
        type: "hidden",
        name: "accessToken",
        value: $setup.useGetAccessToken()
      }, null, 8 /* PROPS */, _hoisted_5)
    ])
  ]))
}